import React, { useState, useContext, useEffect } from 'react';
import GlobalContext from "../../../contexts/globalContext";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { getToken, getCommentsByParentPaginated, CONTENT_TYPE_ARTICULO } from "../../../services/social.services";
import Button from '../../atoms/button/button';
import Select from 'react-select';
import CommentsContext from "../../../contexts/commentsContext";
import CommentReply from '../../molecules/comment-reply/comment-reply';
import { getComments } from '../../molecules/comment-main/comment-main';
import TitleSection from '../../molecules/title-section';
import Loading from '../../atoms/loading/loading';
import moment from 'moment';
import { SortingOpts } from "../../../data/foro.data.js";

// Styles //
import "./comment-section.scss";


const CommentSection = (props) => {

  const Context = useContext(GlobalContext);
  const { isBrowser } = useBrowserMode();
  const today = moment(Date.now()).format('DD/MM/YYYY');
  let defaultCurrentUserData = {
    userdoc: "",
    userpic: "",
    username: "",
    usermail: "",
    date: ""
  };

  const [currentUserData, setCurrentUserData] = useState(defaultCurrentUserData);
  const [gigyaData, setGigyaData] = useState({});

  const dropdownStyles = {
    control: (styles) => {
      return {
        ...styles,
        backgroundColor: "var(--color-coconut-dark)"
      };
    },
    menu: styles => ({
      ...styles,
      marginTop: 0,
      backgroundColor: "var(--color-coconut-dark)"
    }),
    option: (styles, state) => {
      return {
        ...styles,
        backgroundColor: state.isFocused ? "#ee2b7b" : "var(--color-coconut-dark)",
        color: "var(--color-dark-white)",
        cursor: "default"
      };
    },
    singleValue:(styles) => ({
      ...styles,
      color: "var(--color-dark-white)"
    }),
  };

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
      if (!Context.gigyaContext.gigyaAccount) {
          setIsLoggedIn(false);
          const timer = setTimeout(() => {
              if (!Context.gigyaContext.gigyaAccount) {
                  Context.gigyaContext.loginComfamaId!();
              }
          }, 2500);
          return () => clearTimeout(timer);
      } else {
          if (isBrowser) {
              setIsLoggedIn(true);
              if (Context.gigyaContext.gigyaAccount.profile.email) {
                setGigyaData(Context.gigyaContext.gigyaAccount);
                setCurrentUserData({
                    ...currentUserData,
                    userdoc: Context.gigyaContext.gigyaAccount.data.docNumber,
                    userpic: Context.gigyaContext.gigyaAccount?.profile.photoURL!,
                    username: Context.gigyaContext.gigyaAccount!.profile.firstName + " " + Context.gigyaContext.gigyaAccount!.profile.lastName,
                    usermail: Context.gigyaContext.gigyaAccount!.profile.email,
                    date: today
                });
              }
          }
      }
  }, [Context.gigyaContext.gigyaAccount]);

  const [comments, setComments] = useState<any>([]);
  const [isLoadingComments, setIsLoadingComments] = useState(false);

  const [sortOpt, setSortOpt] = useState(1);
  const ordenar = (opt) => {
    let auxList = [...comments];
    auxList.sort(sortByISODate);
    if (opt == 2) auxList = auxList.reverse();
    setComments([...auxList]);
  }

  const sortByISODate = (o1, o2) => {
    return o2.dateEditFull > o1.dateEditFull ? 1 : o2.dateEditFull < o1.dateEditFull ? -1 : 0;
  }

  const pageSize = 6;
  const [pageStart, setPageStart] = useState(0);
  const cargarMasComentarios = async () => {
    setPageStart(pageStart+1);
  }
  
  const cargarComentarios = async () => {
    setIsLoadingComments(true);
    const token = await getToken(Context?.gigyaContext?.gigyaAccount ? Context?.gigyaContext?.gigyaAccount?.UID : null);
    const response: any = await getCommentsByParentPaginated(token, props.contentId, CONTENT_TYPE_ARTICULO, pageStart, pageSize);
    const newComments: any = response.data.data ? response.data.data : [] ;
    let auxList = [...comments, ...newComments];
    if (pageStart > 0)
      auxList.sort(sortByISODate);
    if (sortOpt == 2)
      auxList = auxList.reverse();
    setComments(auxList);
    setIsLoadingComments(false);
  }

  useEffect(() => {
    cargarComentarios();
  }, [pageStart]);


  useEffect(() => {
    ordenar(sortOpt);
  }, [sortOpt]);

  return (
      <>
        <CommentsContext.Provider value={[currentUserData, gigyaData, comments, setComments]}>
          <div className="o-comment-section">
              
              <div className="comments-title-section">
                  <div className="title">
                      {/* <TitleSection title={props.tituloGeneral} /> */}
                      <TitleSection title="Agrega un comentario" />
                  </div>
                  <div className="sorting">
                    <div className="sorting-text">
                      Ordenar por
                    </div>
                    <div className="sorting-options-btn">
                        <Select className="sorting-options-btn-select"
                                isSearchable={false}
                                options={SortingOpts}
                                styles={dropdownStyles}
                                placeholder="Selecciona"
                                onChange={(option: any) => setSortOpt(option.value)}/>
                    </div>
                  </div>
              </div>
              
              <CommentReply {...currentUserData} parentContentType={CONTENT_TYPE_ARTICULO} parentContentId={props.contentId} grandParentContentId={props.contentId}/>

              <div className="comments-showing">{`Mostrando ${comments.length} comentarios`}</div>

              {getComments(comments, null)}
            
              <br/>
              <br/>

              <div className="comments-load-more">

                <div className={`loading ${isLoadingComments ? "" : "hidden"}`}>
                  <Loading/>
                </div>

                <div className={`loading ${isLoadingComments ? "hidden" : ""}`}>
                  <Button
                      type="button"
                      text="CARGAR MÁS COMENTARIOS"
                      classname={`a-button__magenta ${comments.length} comentarios`}
                      href={void(0)}
                      isDisabled={false}
                      onClickAction={cargarMasComentarios}/>
                </div>
              </div>
          </div>
        </CommentsContext.Provider>
      </>
  )

}

export default CommentSection;


export const removeComment = (commentList: any[], idContenido: any) => {
  let auxList = [...commentList];
  for (let listIdx = 0; listIdx < auxList.length; listIdx++) {
      if (auxList[listIdx]["idContenido"] == idContenido) {
        auxList.splice(listIdx, 1);
          break;
      }
      else {
        auxList[listIdx].replies = removeComment(auxList[listIdx].replies, idContenido);
      }
  }
  return auxList;
}

export const addComment = (newElement:any, commentList: any[], idContenidoPadre: any) => {
  let auxList = [...commentList];
  if (!idContenidoPadre) auxList.push(newElement);
  else {
    for (let listIdx = 0; listIdx < auxList.length; listIdx++) {
        if (auxList[listIdx]["idContenido"] == idContenidoPadre) {
          auxList[listIdx].replies.push(newElement);
            break;
        }
        else {
          auxList[listIdx].replies = addComment(newElement, auxList[listIdx].replies, idContenidoPadre);
        }
    }
  }
  return auxList;
}

export const updateComment = (newElement:any, commentList: any[], idContenido: any) => {
  let auxList = [...commentList];
  for (let listIdx = 0; listIdx < auxList.length; listIdx++) {
      if (auxList[listIdx]["idContenido"] == idContenido) {
        auxList.splice(listIdx, 1, newElement);
          break;
      }
      else {
        auxList[listIdx].replies = updateComment(newElement, auxList[listIdx].replies, idContenido);
      }
  }
  return auxList;
}